import { Link } from "react-router-dom";
import { articles } from "@/mocks/content";
import { categoryName, formatViews } from "@/components/feature/ArticleCard";

export default function HeroSection() {
  const [lead, ...rest] = articles;
  const sideStories = rest.slice(0, 4);

  return (
    <section aria-labelledby="hero-title" className="w-full border-b border-background-200/70 bg-background-100/50">
      <div className="mx-auto w-full px-4 py-8 md:px-6 md:py-12">
        <div className="mb-6 flex flex-col gap-2">
          <span className="flex items-center gap-2 text-xs font-medium tracking-[0.2em] text-primary-600">
            <span className="flex h-4 w-4 items-center justify-center">
              <i className="ri-alarm-warning-line text-base" aria-hidden="true" />
            </span>
            TODAY&apos;S MELON
          </span>
          <h1 id="hero-title" className="font-heading text-2xl font-black leading-tight text-foreground-950 md:text-4xl">
            网红吃瓜今日瓜，新鲜瓜料速递第一站
          </h1>
          <p className="max-w-3xl text-sm leading-relaxed text-foreground-600 md:text-base">
            点开就能看到网红圈今天在聊什么。聊天记录、事件时间线、当事方回应一网打尽，
            把散落的瓜料整理成 5 分钟能看懂的完整脉络。
          </p>
        </div>

        <div className="grid grid-cols-1 gap-5 lg:grid-cols-3">
          <article className="group relative col-span-1 overflow-hidden rounded-lg lg:col-span-2">
            <Link to={`/news/${lead.id}`} className="block">
              <div className="relative h-[300px] w-full md:h-[430px]">
                <img
                  src={lead.cover}
                  alt={`${lead.title} 事件现场示意图`}
                  title={`${lead.title} - 吃瓜日报今日瓜`}
                  className="h-full w-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/90 via-foreground-950/45 to-foreground-950/10" />
              </div>
              <div className="absolute inset-x-0 bottom-0 p-5 md:p-7">
                <div className="mb-3 flex flex-wrap items-center gap-2">
                  <span className="flex items-center gap-1 rounded-full bg-primary-500 px-2.5 py-1 text-xs font-medium text-background-50">
                    <i className="ri-fire-fill text-[13px]" aria-hidden="true" />
                    今日热瓜
                  </span>
                  <span className="rounded-full bg-background-50/20 px-2.5 py-1 text-xs font-medium text-background-50 backdrop-blur-sm">
                    {categoryName(lead.category)}
                  </span>
                </div>
                <h2 className="font-heading text-xl font-bold leading-snug text-background-50 md:text-3xl">
                  {lead.title}
                </h2>
                <p className="clamp-2 mt-2.5 hidden max-w-2xl text-sm leading-relaxed text-background-200 sm:block">
                  {lead.summary}
                </p>
                <div className="mt-4 flex flex-wrap items-center gap-3 text-xs text-background-200">
                  <span>{lead.author}</span>
                  <span className="h-1 w-1 rounded-full bg-background-300/70" />
                  <span>{lead.publishedAt}</span>
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line text-sm" aria-hidden="true" />
                    {formatViews(lead.views)}
                  </span>
                  <span className="ml-auto flex items-center gap-1 font-medium text-primary-300">
                    查看时间线
                    <i className="ri-arrow-right-line text-sm" aria-hidden="true" />
                  </span>
                </div>
              </div>
            </Link>
          </article>

          <div className="flex flex-col gap-3">
            <h2 className="flex items-center gap-2 font-heading text-base font-bold text-foreground-950">
              <span className="flex h-4 w-4 items-center justify-center text-secondary-600">
                <i className="ri-lightbulb-flash-line text-base" aria-hidden="true" />
              </span>
              今日必看
            </h2>
            {sideStories.map((story, index) => (
              <Link
                key={story.id}
                to={`/news/${story.id}`}
                className="group flex items-start gap-3 rounded-lg border border-background-200/80 bg-background-50 p-3 transition-colors duration-200 hover:border-primary-300"
              >
                <span
                  className={`flex h-6 w-6 shrink-0 items-center justify-center rounded-md font-heading text-xs font-bold ${
                    index === 0
                      ? "bg-primary-500 text-background-50"
                      : "bg-background-200 text-foreground-700"
                  }`}
                >
                  {index + 1}
                </span>
                <span className="min-w-0">
                  <span className="clamp-2 block font-heading text-sm font-semibold leading-snug text-foreground-950 transition-colors duration-200 group-hover:text-primary-600">
                    {story.title}
                  </span>
                  <span className="mt-1.5 flex items-center gap-2 text-xs text-foreground-500">
                    <span>{categoryName(story.category)}</span>
                    <span className="flex items-center gap-1">
                      <i className="ri-fire-line text-sm text-primary-400" aria-hidden="true" />
                      {formatViews(story.views)}
                    </span>
                  </span>
                </span>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}